import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  // View actions
  subscribeResource: ['hours', 'hourStart', 'idLibrary', 'typeResource'],
  // Reducer
  subscribeResourceClear: null,
  subscribeResourceRequest: null,
  subscribeResourceSuccess: null,
  subscribeResourceFailure: ['error']
});

export { Creators, Types };
